import type * as Types from '../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type GetRegistryShippingAddressQueryVariables = Types.Exact<{
  eventHandle: Types.Scalars['String'];
}>;

export type GetRegistryShippingAddressQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    registry?: {
      __typename?: 'EventData';
      id: string;
      shippingAddress?: {
        __typename?: 'ShippingAddress';
        name?: string | null;
        phone?: string | null;
        address1: string;
        address2?: string | null;
        postalCode?: string | null;
        city: string;
        state: string;
        countryCode?: string | null;
        country: string;
        validated: boolean;
      } | null;
    } | null;
  } | null;
};

export type GetShippingAddressPayoutCountryQueryVariables = Types.Exact<{
  eventId: Types.Scalars['ID'];
}>;

export type GetShippingAddressPayoutCountryQuery = {
  __typename?: 'Query';
  getRegistryEventData?: { __typename?: 'EventData'; id: string; payoutAccount?: { __typename?: 'RegistryPayoutAccount'; countryCode: string } | null } | null;
};

export const GetRegistryShippingAddressDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetRegistryShippingAddress' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventHandle' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'registry' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'shippingAddress' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address1' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'address2' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'postalCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'city' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'countryCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'country' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'validated' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetRegistryShippingAddressQuery__
 *
 * To run a query within a React component, call `useGetRegistryShippingAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistryShippingAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistryShippingAddressQuery({
 *   variables: {
 *      eventHandle: // value for 'eventHandle'
 *   },
 * });
 */
export function useGetRegistryShippingAddressQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRegistryShippingAddressQuery, GetRegistryShippingAddressQueryVariables>) {
  return ApolloReactHooks.useQuery<GetRegistryShippingAddressQuery, GetRegistryShippingAddressQueryVariables>(GetRegistryShippingAddressDocument, baseOptions);
}
export function useGetRegistryShippingAddressLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRegistryShippingAddressQuery, GetRegistryShippingAddressQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetRegistryShippingAddressQuery, GetRegistryShippingAddressQueryVariables>(GetRegistryShippingAddressDocument, baseOptions);
}
export type GetRegistryShippingAddressQueryHookResult = ReturnType<typeof useGetRegistryShippingAddressQuery>;
export type GetRegistryShippingAddressLazyQueryHookResult = ReturnType<typeof useGetRegistryShippingAddressLazyQuery>;
export type GetRegistryShippingAddressQueryResult = Apollo.QueryResult<GetRegistryShippingAddressQuery, GetRegistryShippingAddressQueryVariables>;
export const GetShippingAddressPayoutCountryDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetShippingAddressPayoutCountry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'getRegistryEventData' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'eventId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'eventId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'payoutAccount' },
                  selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'countryCode' } }] },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useGetShippingAddressPayoutCountryQuery__
 *
 * To run a query within a React component, call `useGetShippingAddressPayoutCountryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShippingAddressPayoutCountryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShippingAddressPayoutCountryQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetShippingAddressPayoutCountryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<GetShippingAddressPayoutCountryQuery, GetShippingAddressPayoutCountryQueryVariables>,
) {
  return ApolloReactHooks.useQuery<GetShippingAddressPayoutCountryQuery, GetShippingAddressPayoutCountryQueryVariables>(GetShippingAddressPayoutCountryDocument, baseOptions);
}
export function useGetShippingAddressPayoutCountryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetShippingAddressPayoutCountryQuery, GetShippingAddressPayoutCountryQueryVariables>,
) {
  return ApolloReactHooks.useLazyQuery<GetShippingAddressPayoutCountryQuery, GetShippingAddressPayoutCountryQueryVariables>(GetShippingAddressPayoutCountryDocument, baseOptions);
}
export type GetShippingAddressPayoutCountryQueryHookResult = ReturnType<typeof useGetShippingAddressPayoutCountryQuery>;
export type GetShippingAddressPayoutCountryLazyQueryHookResult = ReturnType<typeof useGetShippingAddressPayoutCountryLazyQuery>;
export type GetShippingAddressPayoutCountryQueryResult = Apollo.QueryResult<GetShippingAddressPayoutCountryQuery, GetShippingAddressPayoutCountryQueryVariables>;
